import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";
import { Button } from "@/components/ui/button";

export const EMPTY_INTAKE = {
  reason: "", medical_history: "", medications: "", allergies: "", emergency_name: "", emergency_phone: "", consent: false,
};

const FIELDS = [
  ["reason", "What brings you in? *", "e.g. lower back pain for 3 weeks", true],
  ["medical_history", "Relevant medical history", "Past injuries, surgeries, conditions", true],
  ["medications", "Current medications", "", false],
  ["allergies", "Allergies", "", false],
  ["emergency_name", "Emergency contact name", "", false],
  ["emergency_phone", "Emergency contact phone", "", false],
];

export const IntakeForm = ({ value, onChange, onSubmit }) => (
  <form className="rounded-2xl border border-border bg-card p-6 space-y-5" data-testid="intake-form"
    onSubmit={(e) => { e.preventDefault(); onSubmit(); }}>
    <div>
      <p className="font-display font-bold text-lg">Patient intake form</p>
      <p className="text-sm text-muted-foreground">Only the clinic you're booking with can see these answers.</p>
    </div>
    <div className="grid sm:grid-cols-2 gap-4">
      {FIELDS.map(([k, label, ph, long]) => (
        <div key={k} className={`space-y-1.5 ${long ? "sm:col-span-2" : ""}`}>
          <Label htmlFor={k}>{label}</Label>
          {long ? (
            <Textarea id={k} value={value[k]} placeholder={ph} required={k === "reason"} onChange={(e) => onChange({ ...value, [k]: e.target.value })} data-testid={`intake-${k}-input`} />
          ) : (
            <Input id={k} value={value[k]} placeholder={ph} onChange={(e) => onChange({ ...value, [k]: e.target.value })} data-testid={`intake-${k}-input`} />
          )}
        </div>
      ))}
    </div>
    <label className="flex items-start gap-3 text-sm">
      <Checkbox checked={value.consent} onCheckedChange={(v) => onChange({ ...value, consent: !!v })} data-testid="intake-consent-checkbox" />
      <span>I confirm this information is accurate and consent to the clinic using it for my care.</span>
    </label>
    <Button type="submit" className="rounded-full" disabled={!value.consent || !value.reason.trim()} data-testid="intake-form-submit-button">Continue to payment</Button>
  </form>
);
